import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { environment } from '../../environments/environment';
import { config } from '../config';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-covid-protection',
  templateUrl: './covid-protection.component.html',
  styleUrls: ['./covid-protection.component.css']
})
export class CovidProtectionComponent implements OnInit {

  modalRef: BsModalRef;
  quotesDetailsTable : boolean;
  data: any = {};
  error: any;
  mobile: string;
  contactEmail: string;
  contactMobile: any;
  contactName: string;
  contactCity: any;
  partnerId: any;
  proposalFormDataForCovid: string;
  quoteIdForCovid: string;
  loading :boolean;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router, private modalService: BsModalService, private serviceURLService: serviceURLService) { }

  ngOnInit() {
    // this.saveQuoteDataCovid();
  }

  showQuote(){
    this.quotesDetailsTable =true;
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  downloadPDF() {
    window.open(environment.pam2Url + config.downloadCovidPDF + this.quoteIdForCovid)
  }

  sendPDF(){
    // var prospectIdCovid = localStorage.getItem('prospectIdCovid');
        this.serviceURLService.sendCovidPDF(this.quoteIdForCovid).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
          
        }, errorData => {
          if(errorData.error.status === 403){
            this.error = errorData.error.message;
          }
        })
  }

  saveQuoteDataCovid() {
    this.loading = true;
    var prospectIdCovid = localStorage.getItem('prospectIdCovid');

    this.serviceURLService.saveQuoteDataCovid(prospectIdCovid).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.proposalFormDataForCovid = successData.data;
      this.quoteIdForCovid = successData.data.quoteId;
      localStorage.setItem("quoteIdForCovid", this.quoteIdForCovid)
    }, errorData => {
      console.log("Oops..!! there is some error get proposal form");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

}
